import React from 'react';
import { PaginationButton } from '../../atoms';

/**
 * PaginationControls Molecule Component
 * Previous and Next navigation buttons
 */
const PaginationControls = ({ 
  onPrevious,
  onNext,
  hasPrevious = false,
  hasNext = false,
  className = '',
  ...props 
}) => {
  return (
    <div className={`flex gap-2 ${className}`} {...props}>
      <PaginationButton
        onClick={onPrevious}
        isDisabled={!hasPrevious}
        className="flex items-center"
      >
        Previous
      </PaginationButton>
      <PaginationButton
        onClick={onNext}
        isDisabled={!hasNext}
        className="flex items-center"
      >
        Next
      </PaginationButton>
    </div>
  );
};

export default PaginationControls;

